import * as React from 'react'
import { Box } from '@mui/joy'
import PasswordCritera from './PasswordCriteria'
import PasswordInput from '../PasswordInput'
import useTranslation from '../../../shared/TranslationProvider'

const SetPassword = ({
  password,
  setPassword,
  passwordConfirmation,
  setPasswordConfirmation,
  onKeyDown,
  errors,
  isWhiteText,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Box className="control-container">
        <PasswordInput
          password={password}
          autoComplete="new-password"
          setPassword={setPassword}
          labelValue={t('password')}
          errors={errors}
          isWhiteText={isWhiteText}
        />
      </Box>
      <Box className="criteria-container">
        <PasswordCritera password={password} isWhiteText={isWhiteText} />
      </Box>

      <Box className="control-container">
        <PasswordInput
          password={passwordConfirmation}
          autoComplete="new-password"
          setPassword={setPasswordConfirmation}
          name="password_confirmation"
          labelValue={t('SetPassword.confirm_password')}
          onKeyDown={onKeyDown}
          errors={errors}
          isWhiteText={isWhiteText}
        />
      </Box>
    </>
  )
}

export default SetPassword
